/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Avoid_Real_WordsInputs */

const en_avoid_real_words = /** @type {(inputs: Avoid_Real_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avoid the use of real words or abbreviations. They will automatically be replaced.`)
};

const fr_avoid_real_words = /** @type {(inputs: Avoid_Real_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évitez l'utilisation de mots réels ou d'abréviations. Ils seront automatiquement remplacés.`)
};

const de_avoid_real_words = /** @type {(inputs: Avoid_Real_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte verwenden Sie keine echten Wörter oder Abkürzungen. Diese werden automatisch ersetzt.`)
};

const it_avoid_real_words = /** @type {(inputs: Avoid_Real_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evitate l'uso di parole reali o abbreviazioni. Verranno automaticamente sostituite.`)
};

const ru_avoid_real_words = /** @type {(inputs: Avoid_Real_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Избегайте использования настоящих слов или сокращений. Они будут автоматически заменены.`)
};

const es_avoid_real_words = /** @type {(inputs: Avoid_Real_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evite usar palabras reales o abreviaturas. Se reemplazarán automáticamente.`)
};

const zh_cn2_avoid_real_words = /** @type {(inputs: Avoid_Real_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`避免使用真实单词或缩写。它们将被自动替换。`)
};

const ja_avoid_real_words = /** @type {(inputs: Avoid_Real_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実在の単語や略語の使用は避けてください。それらは自動的に置き換えられます。`)
};

const hi_avoid_real_words = /** @type {(inputs: Avoid_Real_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वास्तविक शब्दों या संक्षिप्ताक्षरों का प्रयोग करने से बचें। इन्हें स्वचालित रूप से बदल दिया जाएगा।`)
};

const pt_pt2_avoid_real_words = /** @type {(inputs: Avoid_Real_WordsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evite o uso de palavras reais ou abreviações. Elas serão substituídas automaticamente.`)
};

/**
* | output |
* | --- |
* | "Avoid the use of real words or abbreviations. They will automatically be replaced." |
*
* @param {Avoid_Real_WordsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const avoid_real_words = /** @type {((inputs?: Avoid_Real_WordsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Avoid_Real_WordsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_avoid_real_words(inputs)
	if (locale === "de") return de_avoid_real_words(inputs)
	if (locale === "it") return it_avoid_real_words(inputs)
	if (locale === "ru") return ru_avoid_real_words(inputs)
	if (locale === "es") return es_avoid_real_words(inputs)
	if (locale === "zh-CN") return zh_cn2_avoid_real_words(inputs)
	if (locale === "ja") return ja_avoid_real_words(inputs)
	if (locale === "hi") return hi_avoid_real_words(inputs)
	if (locale === "pt-PT") return pt_pt2_avoid_real_words(inputs)
	return en_avoid_real_words(inputs)
});